import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Link, NavLink } from 'react-router-dom';
import { showError, showSuccess } from '../../services/toastService';
import { Modal, Input, Form, Button } from 'antd';

const { confirm } = Modal;

function showConfirm(onConfirm, onCancel) {
    confirm({
        title: 'Confirm Logout',
        content: 'Are you sure you want to logout?',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk() {
            if (onConfirm) {
                onConfirm();
            }
        },
        onCancel() {
            if (onCancel) {
                onCancel();
            }
        },
    });
}

function Aside({ userData }) {
    const { logout, updatePassword } = useAuth(); // Assuming you have a changePassword method in your Auth context

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();

    const handleLogout = async () => {
        showConfirm(
            async () => {
                try {
                    await logout();
                    showSuccess('Logout successful!');
                } catch (error) {
                    console.log(error);
                    showError('Invalid credentials'); // Show error message
                }
            },
            () => {
                console.log('Logout canceled');
            }
        );
    };



    const [openDeviceSubmenu, setOpenDeviceSubmenu] = useState(null);
    const [openLevel1, setOpenLevel1] = useState(false);

    const toggleLevel1 = () => {
        setOpenLevel1((prev) => !prev); // Toggle level 1 menu
    };

    const toggleDeviceSubmenu = (deviceId) => {
        setOpenDeviceSubmenu((prev) => (prev === deviceId ? null : deviceId)); // Toggle clicked device submenu and close others
    };

    const handleChangePassword = () => {
        setIsModalVisible(true); // Show modal
    };

    const handlePasswordSubmit = async (values) => {
        try {
            const res = await updatePassword(values); // Call the change password API
            console.log(res);
            if (res && res.status === true) { // Check if the response indicates success
                showSuccess('Password changed successfully!');
                setIsModalVisible(false); // Hide modal after success
                form.resetFields(); // Reset the form
            } else {
                // If the API returns an error status or message, handle it here
                showError(res?.response?.data?.message || 'Failed to change password'); // Display the error message
            }
        } catch (error) {
            console.error('Error in handlePasswordSubmit:', error);
            showError(error.message || 'Failed to change password'); // Display a generic error message if none is provided
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false); // Hide modal
    };

    return (
        <aside className="main-sidebar sidebar-dark-primary elevation-3" >
            <a href="#" className="brand-link bg-white text-center" >
                <img src="assets/images/pluss.png" alt="Logo" className='brand-image elevation-3' style={{ float: 'none' }} />
                <span className="brand-text font-weight-light"></span>
            </a>
            <div className="sidebar">
                <div className="user-panel mt-3 pb-3 mb-3 d-flex">
                    <div className="info">
                        <a href="#" className="d-block">{userData?.name}</a>
                    </div>
                </div>
                <nav className="mt-2">
                    {userData.role === 'SUPERADMIN' && (
                        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false" >
                            <li className="nav-item" key={`dashboard`}>
                                <Link to="dashboard" className="nav-link">
                                    <i className="nav-icon fas fa-tachometer-alt"></i>
                                    <p>Dashboard</p>
                                </Link>
                            </li>
                            <li className="nav-item" key={`clients`}>
                                <Link to="clients" className="nav-link">
                                    <i className="nav-icon fas fa-users"></i>
                                    <p>Customers</p>
                                </Link>
                            </li>
                            <li className="nav-item" key={`devices`}>
                                <Link to="devices" className="nav-link">
                                    <i className="nav-icon fa fa-hdd"></i>
                                    <p>Devices</p>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <a href="#" className="nav-link" onClick={handleChangePassword}>
                                    <i className="nav-icon fa fa-key"></i>
                                    <p>Change Password</p>
                                </a>
                            </li>
                            <li className="nav-item" key={`logout`}>
                                <a href="#" className="nav-link" onClick={handleLogout}>
                                    <i className="nav-icon fa fa-sign-out-alt"></i>
                                    <p>Logout</p>
                                </a>
                            </li>
                        </ul>
                    )}
                    {userData.role === 'CLIENT' && (
                        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false" >
                            <li className="nav-item" key={`dashboard`}>
                                <Link to="dashboard" className="nav-link">
                                    <i className="nav-icon fas fa-tachometer-alt"></i>
                                    <p>Dashboard</p>
                                </Link>
                            </li>
                            <li className="nav-header">Device Management</li>
                            <li className={`nav-item has-treeview ${openLevel1 ? 'menu-open' : ''}`}>
                                <a href="#" className="nav-link" onClick={toggleLevel1}>
                                    <i className="nav-icon fas fa-hdd"></i>
                                    <p>
                                        Devices
                                        <i className={`right fas ${openLevel1 ? 'fa-angle-down' : 'fa-angle-left'}`}></i>
                                    </p>
                                </a>
                                <ul className={`nav nav-treeview ${openLevel1 ? 'd-block' : 'd-none'}`}>
                                    {userData?.deviceList && userData.deviceList.map((device) => (
                                        <li key={device.device_id} className={`nav-item has-treeview ${openDeviceSubmenu === device.device_id ? 'menu-open' : ''}`}>
                                            <a href="#" className="nav-link" onClick={() => toggleDeviceSubmenu(device.device_id)}>
                                                <i className="far fa-circle nav-icon"></i>
                                                <p >
                                                    {device.name}
                                                    <i className={`right fas ${openDeviceSubmenu === device.device_id ? 'fa-angle-down' : 'fa-angle-left'}`}></i>
                                                </p>
                                            </a>
                                            <ul className={`nav nav-treeview ${openDeviceSubmenu === device.device_id ? 'd-block' : 'd-none'}`} style={{ marginLeft: 20 }}>
                                                <li className="nav-item">
                                                    <NavLink to={`graphical?device=${device.device_id}`} className="nav-link">
                                                        <i className="fas fa-digital-tachograph nav-icon"></i>
                                                        <p>Graphical Data</p>
                                                    </NavLink>
                                                </li>
                                                <li className="nav-item">
                                                    <NavLink to={`tabular?device=${device.device_id}`} className="nav-link">
                                                        <i className="fas fa-table nav-icon"></i>
                                                        <p>Tabular Data</p>
                                                    </NavLink>
                                                </li>
                                                <li className="nav-item">
                                                    <NavLink to={`export?device=${device.device_id}`} className="nav-link">
                                                        <i className="fas fa-download nav-icon"></i>
                                                        <p>Export Data</p>
                                                    </NavLink>
                                                </li>
                                            </ul>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                            {/* <li className="nav-header">Administration</li> */}
                            <li className="nav-item">
                                <a href="#" className="nav-link" onClick={handleChangePassword}>
                                    <i className="nav-icon fa fa-key"></i>
                                    <p>Change Password</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="#" className="nav-link" onClick={handleLogout}>
                                    <i className="nav-icon fa fa-sign-out-alt"></i>
                                    <p>Logout</p>
                                </a>
                            </li>
                        </ul>
                    )}
                    <img src="assets/images/himacool.png" alt="Logo" className="brand-images" style={{ position: 'absolute', bottom: 15 }} />
                </nav>
            </div>
            {/* Modal for changing password */}
            <Modal
                title="Change Password"
                open={isModalVisible}
                layout="vertical"
                onCancel={handleCancel}
                footer={null}
            >
                <Form form={form} onFinish={handlePasswordSubmit} layout="vertical">

                    <Form.Item
                        label="Current Password"
                        name="currentPassword"
                        rules={[{ required: true, message: 'Please input your current password!' }]}
                    >
                        <Input.Password />
                    </Form.Item>
                    <Form.Item
                        label="New Password"
                        name="newPassword"
                        rules={[{ required: true, message: 'Please input your new password!' }]}
                    >
                        <Input.Password />
                    </Form.Item>
                    <Form.Item
                        label="Confirm New Password"
                        name="confirmNewPassword"
                        dependencies={['newPassword']}
                        rules={[
                            { required: true, message: 'Please confirm your new password!' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('newPassword') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('The two passwords do not match!'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Change Password
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </aside>
    );
}

export default Aside;
